<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Card -->
        <div class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="fas fa-random text-success"></i>
                    </span>
                    <h3 class="card-label">Hashtag Shuffle</h3>
                </div>
            </div>

            <div class="card-body">
                <form ref="shuffleHashtagsForm" v-on:submit.prevent="shuffleHashtagSet">
                    <!-- Hashtags to shuffle -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Hashtags to shuffle"
                        label-for="input-default"
                    >
                        <b-form-textarea
                            id="hashtags"
                            name="hashtags"
                            placeholder="Enter hashtags here..."
                            rows="3"
                            max-rows="6"
                            v-model="hashtags"
                        ></b-form-textarea>
                    </b-form-group>

                    <!-- Range slider -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        :label="'Number of hashtags (' + shuffleCount + ')'"
                        label-for="input-default"
                    >
                        <b-form-input
                            id="hashtagrange"
                            name="hashtagrange"
                            v-model="shuffleCount"
                            type="range"
                            min="1"
                            max="35"
                            class="h-100"
                        ></b-form-input>
                    </b-form-group>

                    <!-- Remove duplicates -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Remove duplicates?"
                        class="mb-1"
                    >
                        <b-form-checkbox
                            switch
                            size="lg"
                            name="relevant"
                            class="pt-2"
                            v-model="removeDuplicates"
                        ></b-form-checkbox>
                    </b-form-group>

                    <!-- Results -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Results"
                        label-for="input-default"
                    >
                        <b-form-textarea
                            placeholder="Your shuffled hashtags will be displayed here..."
                            rows="3"
                            max-rows="6"
                            v-bind:value="shuffledhashtags"
                        ></b-form-textarea>
                    </b-form-group>
                </form>
            </div>
            <div class="card-footer">
                <b-button
                    variant="success"
                    class="offset-xl-2 col-xl-3 mb-3 mr-4"
                    @click="shuffleHashtagSet(hashtags, shuffleCount, removeDuplicates, 'global')"
                >
                    Shuffle Hashtags
                </b-button>
                <button class="btn btn-light-success copy-hashtags-button mb-3 col-xl-3">
                    <i class="far fa-clipboard"></i>
                    <span class="innerText">Copy to clipboard</span>
                </button>
                <p class="copyHashtags" style="position: absolute; left: -99999999em">
                    {{ shuffledhashtags }}
                </p>
            </div>
        </div>
        <!-- End card -->
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import hashtagShuffle from "@/mixins/hashtagShuffle";

export default {
    name: "HashtagShufflePage",
    mixins: [hashtagShuffle],
    components: {
        PagePreloader,
        CustomAlerts,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,

            // Displayers

            // Error management
            errors: [],

            // Forms
            hashtags: "",
            shuffleCount: 15,
            shuffledhashtags: "",
            removeDuplicates: false,
        };
    },

    methods: {
        // prepareShuffleString(hashtags) {
        //     var find = "#";
        //     var re = new RegExp(find, "g");

        //     var hashtagstoshuffle = hashtags;

        //     hashtagstoshuffle = hashtagstoshuffle.replace(re, " "); // Replace hashtags with spaces
        //     hashtagstoshuffle = hashtagstoshuffle.replace(/\s\s+/g, " "); // Replace multiple spaces with single space
        //     hashtagstoshuffle = hashtagstoshuffle.trim(); // Replace whitespace at start and end of string
        //     hashtagstoshuffle = hashtagstoshuffle.split(" "); // Create array of single-separated hashtags

        //     // Check if we should remove duplicates
        //     if (this.removeDuplicates) {
        //         hashtagstoshuffle = [...new Set(hashtagstoshuffle)];
        //     }

        //     return hashtagstoshuffle;
        // },

        // shuffleHashtagSet() {
        //     // Do stuff here
        //     this.errors = [];

        //     // Get hashtags
        //     var hashtagstoshuffle = this.prepareShuffleString(this.hashtags);

        //     var counttoshuffle = this.shuffleCount;

        //     // Do the shuffle
        //     this.shuffledhashtags = this.doHashtagShuffle(hashtagstoshuffle, counttoshuffle);
        // },

        // doHashtagShuffle(arr, n) {
        //     var result = new Array(n),
        //         len = arr.length,
        //         taken = new Array(len);
        //     if (n > len) {
        //         // throw new RangeError("getRandom: more elements taken than available");
        //         this.errors.push({
        //             type: "warning",
        //             message:
        //                 "You're trying to shuffle more hashtags than there are in your hashtag set.",
        //         });
        //         return " ";
        //     }
        //     while (n--) {
        //         var x = Math.floor(Math.random() * len);
        //         result[n] = arr[x in taken ? taken[x] : x];
        //         taken[x] = --len in taken ? taken[len] : len;
        //     }
        //     return "#" + result.join(" #");
        // },

        initCopyHashtags() {
            var clipboard = new ClipboardJS(".copy-hashtags-button", {
                target: function (trigger) {
                    return trigger.nextElementSibling;
                },
            });

            clipboard.on("success", function (e) {
                e.trigger.children[1].innerText = "Copied!";
                setTimeout(function () {
                    e.trigger.children[1].innerText = "Copy to clipboard";
                }, 2000);
            });
        },
    },

    mounted() {
        // Set page preloader
        this.pageIsLoaded = true;

        // Init
        this.initCopyHashtags();

        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "MyHashtags", route: "myhashtags" },
            { title: "Shuffle Hashtags", route: "shuffle" },
        ]);
    },
};
</script>
